import './assets/main.css'

import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import store from './store'

import authHandler from './authHandler';
import sessionManager from './sessionManager';

import toastMixin, { showToast } from './mixins/toast.js';

const app = createApp(App);

// Use a relative base so API requests are same-origin. In dev, Vite proxies
// /api to the backend (see vite.config.js); in prod, nginx proxies /api.
// This keeps the session cookie first-party so browsers send it on every request.
app.config.globalProperties.$BACKEND_HOST = '';
app.config.globalProperties.$sessionManager = sessionManager;
app.config.globalProperties.$showToast = showToast;

if (typeof window !== 'undefined') {
  window.sessionManager = sessionManager;
  window.showToast = showToast;
  // Intercept native browser alert popups with modern toast notifications
  window.alert = (message) => {
    showToast(message, 'info');
  };
}

app.config.warnHandler = () => {};

app.use(router);
app.use(store);
app.use(authHandler);
app.mixin(toastMixin);

store.dispatch('checkAuth');

app.mount('#app')

